import React from 'react';
import { useRef, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

export function useHorizontalScroll() {
    const elRef = useRef();
    useEffect(() => {
        const el = elRef.current;
        if (!el) return;

        // 1. Mouse wheel horizontal scrolling
        const onWheel = (e) => {
            if (e.deltaY === 0) return;
            e.preventDefault();
            el.scrollTo({
                left: el.scrollLeft + e.deltaY * 1.2, // slightly boost scrolling speed
                behavior: 'auto', // immediate response
            });
        };
        el.addEventListener('wheel', onWheel, { passive: false });

        // 2. Mouse drag-to-scroll
        let isDown = false;
        let startX;
        let scrollLeft;
        let hasMoved = false;

        const onMouseDown = (e) => {
            // Only scroll on left click
            if (e.button !== 0) return;
            isDown = true;
            el.style.cursor = 'grabbing';
            el.style.userSelect = 'none'; // prevent text selection while dragging
            startX = e.pageX - el.offsetLeft;
            scrollLeft = el.scrollLeft;
            hasMoved = false;
        };

        const onMouseLeave = () => {
            if (!isDown) return;
            isDown = false;
            el.style.cursor = 'grab';
            el.style.removeProperty('user-select');
        };

        const onMouseUp = () => {
            if (!isDown) return;
            isDown = false;
            el.style.cursor = 'grab';
            el.style.removeProperty('user-select');
        };

        const onMouseMove = (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - el.offsetLeft;
            const walk = (x - startX) * 1.5; // scroll-fast multiplier
            if (Math.abs(walk) > 5) {
                hasMoved = true;
            }
            el.scrollLeft = scrollLeft - walk;
        };

        // Prevent click if we dragged
        const onClick = (e) => {
            if (hasMoved) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        el.addEventListener('mousedown', onMouseDown);
        el.addEventListener('mouseleave', onMouseLeave);
        el.addEventListener('mouseup', onMouseUp);
        el.addEventListener('mousemove', onMouseMove);
        el.addEventListener('click', onClick, true); // Intercept in capturing phase

        return () => {
            el.removeEventListener('wheel', onWheel);
            el.removeEventListener('mousedown', onMouseDown);
            el.removeEventListener('mouseleave', onMouseLeave);
            el.removeEventListener('mouseup', onMouseUp);
            el.removeEventListener('mousemove', onMouseMove);
            el.removeEventListener('click', onClick, true);
        };
    }, []);
    return elRef;
}

const CategoryMenu = (props) => {
    const scrollRef = useHorizontalScroll();
    return (
        <div
            ref={scrollRef}
            style={{
                overflowX: 'auto',
                overflowY: 'hidden',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                cursor: 'grab',
            }}
            className='w-100 category-menu mb-3'
        >
            <div
                style={{ whiteSpace: 'nowrap' }}
                className='d-flex align-items-center'
            >
                <span
                    onClick={() => {
                        props.onClickCategory('all', 99);
                    }}
                    className={
                        props.activeIndex === 99
                            ? 'active-menu nav_items cursor-pointer py-1 px-3 items-active'
                            : 'nav_items cursor-pointer py-1 px-3 items-active'
                    }
                >
                    Tất cả
                </span>
                {props.category}
            </div>
        </div>
    );
};

export default CategoryMenu;
